export default {
    install(Vue) {

        Vue.prototype.openPaperNewWindow = function(url, item) {
            let openUrl = null;
            if(url == null || url == undefined) {
                openUrl = window.location.href;
            } else {
                openUrl = url + item.paperId;
                if(item.paperProjectLinkId != null) {
                    openUrl = openUrl + '/' + item.paperProjectLinkId;
                }
            }
            window.open(openUrl);
        };
        
    }
}


// WEBPACK FOOTER //
// ./src/js/store/module/common/newWindowFunction.js